import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { Popup } from "semantic-ui-react";
import OpenThreeDotPopup from "../Published_Q_list/OpenThreeDotPopup";
import "./publishAssessBoxActivity.css";
import axios from "../../../../../axios";
import NoResponse from "../../../../Pre-read/Create_Assessment_PreRead/create_successfullPreRead/NoResponse";
import { Tooltip } from "@mui/material";
import { MoreVertical } from "lucide-react";
import PublishedQListActivity from "../Published_Q_list/PublishedQListActivity";

// Subject icon mapper
const getSubjectIcon = (subjectName = "") => {
  const name = subjectName.toLowerCase().trim();

  if (["maths", "mathematics", "math"].some((s) => name.includes(s))) {
    return "/ActivityIcons/Maths_Lab_Icon-removebg-preview.png";
  }
  if (["english"].some((s) => name.includes(s))) {
    return "/ActivityIcons/English_Lab_Icon.png";
  }
  if (["hindi"].some((s) => name.includes(s))) {
    return "/ActivityIcons/Hindi_Lab_Icon-removebg-preview.png";
  }
  if (
    ["science", "physics", "chemistry", "biology", "botany", "zoology"].some(
      (s) => name.includes(s),
    )
  ) {
    return "/ActivityIcons/Science_Lab_Icon-removebg-preview.png";
  }

  return "/ActivityIcons/Any_others_Subjects_Lab_Icon-removebg-preview.png";
};

// Convert hex to RGB
const hexToRgb = (hex) => {
  const cleanHex = hex.replace("#", "");
  const bigint = parseInt(cleanHex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
};

// Create aesthetic gradient from subject color
const getSubjectGradient = (subjectColor = "4169E1") => {
  const hex = subjectColor.startsWith("#") ? subjectColor : `#${subjectColor}`;
  const { r, g, b } = hexToRgb(hex);

  const lightR = Math.min(255, r + 210);
  const lightG = Math.min(255, g + 210);
  const lightB = Math.min(255, b + 210);

  const medR = Math.min(255, r + 160);
  const medG = Math.min(255, g + 160);
  const medB = Math.min(255, b + 160);

  const ultraR = Math.min(255, r + 235);
  const ultraG = Math.min(255, g + 235);
  const ultraB = Math.min(255, b + 235);

  return `linear-gradient(145deg, 
    rgba(${lightR}, ${lightG}, ${lightB}, 0.9) 0%, 
    rgba(${medR}, ${medG}, ${medB}, 0.6) 50%,
    rgba(${ultraR}, ${ultraG}, ${ultraB}, 0.3) 100%)`;
};

// Badge style from subject color
const getSubjectBadgeStyle = (subjectColor = "4169E1") => {
  const hex = subjectColor.startsWith("#") ? subjectColor : `#${subjectColor}`;
  const { r, g, b } = hexToRgb(hex);

  return {
    backgroundColor: `rgba(${r}, ${g}, ${b}, 0.12)`,
    color: hex,
    border: `1px solid rgba(${r}, ${g}, ${b}, 0.25)`,
  };
};

const PublishAssessBoxActivity = ({ filter }) => {
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [publishedCard, setPublishedCard] = useState([]);
  const [noresponse, setNoresponse] = useState(false);
  const [isGettingData, setIsGettingData] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  function convertToISO(dateString) {
    const date = new Date(dateString);
    const isoDate = date.toISOString();
    return isoDate;
  }

  const publishedBox = async () => {
    try {
      let res = await axios.get(
        `/api/v1/homework/activity/filterByTeacherId/${Teacher_Json}/published?academic_session_id=${academicSessionId}&timetable_session_id=${timeTableSessionId}` +
          `&${filter?.standard_id && `standardId=${filter?.standard_id}`}` +
          `&${filter?.section_id && `sectionId=${filter?.section_id}`}` +
          `&${filter?.searchvalue && `name=${filter?.searchvalue}`}` +
          `&${filter?.date && `date=${convertToISO(filter?.date)}`}` +
          `&${filter?.time && `time=${filter?.time}`}` +
          `&${
            filter?.subjectId?.length !== 0 && `subjectId=${filter?.subjectId}`
          }`,
      );
      if (res.data.data.length === 0) {
        setNoresponse(true);
      }

      setPublishedCard(res.data.data);
    } catch (e) {
      console.log(e);
    } finally {
      setIsGettingData(false);
    }
  };

  useEffect(() => {
    publishedBox();
  }, [filter]);

  function shortenParagraph(text, maxLength) {
    if (!text || text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength).trim() + "...";
  }

  return publishedCard && publishedCard.length > 0 ? (
    <>
      <div className="container">
        <div className="row">
          {[...publishedCard]
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            .map((publicData, idx) => {
              const subjectName = publicData?.subject_id?.name || "";
              const subjectColor =
                publicData?.subject_id?.subject_color || "4169E1";
              const activityName = publicData?.name || "";
              const subjectIcon = getSubjectIcon(subjectName);
              const cardGradient = getSubjectGradient(subjectColor);
              const badgeStyle = getSubjectBadgeStyle(subjectColor);

              return (
                <div key={idx} className="col-md-3 d-flex mb-3">
                  <div
                    className="w-100 h-100 d-flex flex-column shadow-sm rounded-4 overflow-hidden position-relative"
                    style={{
                      background: cardGradient,
                      border: "1px solid rgba(255,255,255,0.7)",
                      borderRadius: "1rem",
                      minHeight: "150px",
                      transition: "transform 0.25s ease, box-shadow 0.25s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.boxShadow =
                        "0 16px 32px rgba(0,0,0,0.08)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "";
                    }}
                  >
                    {/* Top bar: 3 dots only */}
                    <div className="d-flex justify-content-end px-3 pt-3">
                      <Popup
                        trigger={
                          <MoreVertical
                            size={18}
                            style={{
                              cursor: "pointer",
                              color: badgeStyle.color,
                            }}
                          />
                        }
                        content={
                          <div className="open_publish_activity_popupBox">
                            <OpenThreeDotPopup
                              publishedActivity_id={publicData?.id}
                              isDeactivated={publishedBox}
                            />
                          </div>
                        }
                        on="click"
                        hideOnScroll
                      />
                    </div>

                    {/* Middle content: Title + Badge + Icon */}
                    <div
                      className="d-flex flex-row justify-content-between align-items-start px-3 flex-grow-1"
                      onClick={() => {
                        setIsPopupOpen(true);
                        setSelectedId(publicData?.id);
                      }}
                      style={{ cursor: "pointer", marginTop: "-4px" }}
                    >
                      {/* Left: Title + Subject badge */}
                      <div className="d-flex flex-column" style={{ flex: 1 }}>
                        {/* Title at top */}
                        <Tooltip
                          title={activityName}
                          arrow
                          placement="bottom"
                          enterDelay={200}
                          leaveDelay={100}
                        >
                          <h6
                            className="poppins-semibold mb-2"
                            style={{
                              fontSize: "1rem",
                              color: "#2d2d2d",
                              lineHeight: 1.3,
                            }}
                          >
                            {shortenParagraph(activityName, 30)}
                          </h6>
                        </Tooltip>

                        {/* Subject badge below title */}
                        <span
                          className="badge rounded-pill px-2 py-1 align-self-start"
                          style={{
                            fontSize: "0.7rem",
                            fontWeight: 600,
                            ...badgeStyle,
                          }}
                        >
                          {`${publicData?.standard_id?.name || ""} - ${
                            publicData?.section_id?.name || ""
                          } | ${shortenParagraph(subjectName, 20)}`}
                        </span>
                      </div>

                      {/* Right: Subject illustration */}
                      <div
                        className="d-flex align-items-end justify-content-end ms-2"
                        style={{ width: "75px", height: "75px", flexShrink: 0 }}
                      >
                        <img
                          src={subjectIcon}
                          alt={subjectName}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            objectPosition: "top right",
                          }}
                        />
                      </div>
                    </div>

                    {/* Bottom: Deadline */}
                    <div className="px-3 pb-3 pt-2">
                      <div
                        className="d-flex align-items-center"
                        style={{ fontSize: "0.8rem", color: "#666" }}
                      >
                        <span className="me-1" style={{ fontSize: "0.85rem" }}>
                          ⏰
                        </span>

                        <span className="ms-1 fw-medium text-dark">
                          {moment(publicData?.deadline).calendar(null, {
                            sameDay: "DD/MM/YYYY",
                            nextDay: "DD/MM/YYYY",
                            nextWeek: "DD/MM/YYYY",
                            lastDay: "DD/MM/YYYY",
                            lastWeek: "DD/MM/YYYY",
                            sameElse: "DD/MM/YYYY",
                          })}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      {isPopupOpen && selectedId && (
        <PublishedQListActivity
          publishedActivity_id={selectedId}
          onClose={() => {
            setIsPopupOpen(false);
            setSelectedId(null);
          }}
        />
      )}
    </>
  ) : isGettingData ? (
    <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
  ) : (
    <div className="d-flex justify-content-center align-items-center w-100">
      <span
        className="badge bg-light text-dark rounded-pill px-4 py-3"
        style={{ fontSize: "1.2rem", letterSpacing: "0.5px" }}
      >
        📭 Activity Not Found
      </span>
    </div>
  );
};

export default PublishAssessBoxActivity;
